import { render, staticRenderFns } from "./SaleQuotationDesign.vue?vue&type=template&id=92094f08&"
import script from "./SaleQuotationDesign.vue?vue&type=script&lang=js&"
export * from "./SaleQuotationDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports